import { IQuyDinhSoBuoiTrenTuan } from "../../model/respone/category/IQuyDinhSoBuoiTrenTuan";
import { apiClient } from "../apiClient";

export const QUY_DINH_SO_BUOI_TREN_TUAN_API = "quy-dinh-so-buoi-tren-tuan";
export const quyDinhSoBuoiTrenTuanApi = {
  SelectAll: () => apiClient.get(`${QUY_DINH_SO_BUOI_TREN_TUAN_API}`),
  Insert: (payload: IQuyDinhSoBuoiTrenTuan) => apiClient.post(`${QUY_DINH_SO_BUOI_TREN_TUAN_API}`, payload),
  Update: (payload: IQuyDinhSoBuoiTrenTuan) => apiClient.put(`${QUY_DINH_SO_BUOI_TREN_TUAN_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${QUY_DINH_SO_BUOI_TREN_TUAN_API}/${id}`),
};
